<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-toolbar color="secondary" flat density="compact">
        <v-toolbar-title>
          <v-icon class="text-accent mr-4">mdi-form-textbox-password</v-icon>
          <span class="text-h6 text-accent">{{ $t("login.changePassword") }}</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon variant="text" @click="onClose">
          <v-icon class="text-accent">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-main v-show="!passwordChanged" class="pa-0">
        <v-form
          ref="passwordForm"
          autocomplete="off"
          v-model="valid"
          class="pa-6"
        >
          <v-text-field
            v-model="oldpassword"
            :counter="50"
            :label="$t('login.oldPassword')"
            :rules="[validationRules.awsPasswordRequirements(this.oldpassword)]"
            :type="show1 ? 'text' : 'password'"
            variant="underlined"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
          ></v-text-field>
          <v-text-field
            v-model="newpassword"
            :counter="50"
            :label="$t('login.newPassword')"
            :rules="[
              validationRules.awsPasswordRequirements(this.newpassword),
              validationRules.mustNotMatch(this.newpassword, this.oldpassword)
            ]"
            :type="show2 ? 'text' : 'password'"
            variant="underlined"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show2 = !show2"
          ></v-text-field>
          <v-text-field
            v-model="confirmpassword"
            :counter="50"
            :label="$t('login.confirmNewPassword')"
            :rules="[
              validationRules.mustMatch(this.confirmpassword, this.newpassword)
            ]"
            :type="show3 ? 'text' : 'password'"
            variant="underlined"
            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show3 = !show3"
          ></v-text-field>
          <p class="text-center mb-4">{{ $t("login.passwordStrength") }}</p>
          <PasswordStrengthMeter :password="newpassword" />
          <p class="text-error">{{ errorText }}</p>
          <v-card-actions class="mt-5 px-0 align-end">
            <v-spacer />
            <v-btn
              @click.stop="onChangePassword"
              :disabled="!this.valid || this.isChangingPassword"
              :loading="this.isChangingPassword"
              >{{ $t("login.changePassword") }}
            </v-btn>
            <v-btn @click.stop="onClose">{{ $t("common.actions.cancel") }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-main>
      <v-container fluid v-show="passwordChanged">
        <v-col align="center" justify="center" class="py-10">
          <h2>{{ $t("login.passwordHasChanged") }}</h2>
          <p>{{ $t("login.pleaseLoginWithNewPassword") }}</p>
          <v-btn class="mt-6" @click.stop="onClose">OK</v-btn>
        </v-col>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import PasswordStrengthMeter from "@/components/PasswordStrengthMeter.vue"
import ValidationRules from "@/utils/validationrules"
import { updatePassword } from "aws-amplify/auth"

let validationRules = null

export default {
  components: {
    PasswordStrengthMeter
  },
  data() {
    return {
      errorText: "",
      show1: false,
      show2: false,
      show3: false,
      valid: false,
      isChangingPassword: false,
      passwordChanged: false,
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      validationRules: validationRules
    }
  },
  props: {
    modelValue: Boolean
  },
  emits: ["update:modelValue"],
  beforeCreate(){ validationRules = ValidationRules() },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser
    },
    show: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit("update:modelValue", value)
      }
    }
  },
  methods: {
    onClose() {
      this.show = false
      this.$refs.passwordForm.reset()
      this.valid = false
      if (this.passwordChanged) {
        this.$store.dispatch("logout")
      }
    },
    async onChangePassword() {
      if (this.valid) {
        this.isChangingPassword = true
        try {
          await updatePassword({
            oldPassword: this.oldpassword,
            newPassword: this.newpassword
          })
          this.errorText = ""
          this.passwordChanged = true

          // TODO: send e-mail to user about the changed password?
        } catch (error) {
          this.errorText = error
        }
        this.isChangingPassword = false
      }
    }
  }
}
</script>
